import type { TolgeeInstance } from '@tolgee/web'
import { tolgeePreProcessor } from '../preProcessor'
import type { I18nPlugin } from '../types'

export const tolgeeBackend = (tolgee: TolgeeInstance): I18nPlugin => ({
  type: 'backend',
  name: 'TolgeeBackend',
  init() {},
  read: async (
    language: string,
    namespace: string,
    callback: (err: Error | null, data?: Record<string, unknown>) => void
  ) =>
    tolgee
      .loadRecord({ language, namespace }, {})
      .then((translations) => {
        const processed = tolgeePreProcessor(translations)
        callback(null, processed)
      })
      .catch((e: unknown) => {
        console.error(e)
        callback(e as Error)
      }),
})
